import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { BtnChiTietSoDuNo } from "./ChiTietSoDuNo/BtnChiTietSoDuNo";

export const ContentTable = ({ listDuNoNhanVay }) => {
  return listDuNoNhanVay.map((item, index) => (
    <div className="custom-table-row" key={"item" + 1}>
      <div className="custom-table-cell username-cell flex-basis-14 flex-basis-16-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center"> {index + 1}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-16 flex-basis-13-6-sm">
        <span className="mobile-column-name">Nhân viên</span>
        <div className="center-wrapper">
          <p className="text-left">{item.UserName}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-50 flex-basis-50-4-sm">
        <span className="mobile-column-name">Số dư nợ</span>
        <div className="center-wrapper">
          <p className="text-right">
            <BtnChiTietSoDuNo item={item} />
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-20 flex-basis-20-sm action-cell">
        <span className="mobile-column-name">Số hợp đồng</span>
        <div className="center-wrapper">
          <p className="text-center">{item.TotalHD}</p>
        </div>
      </div>
    </div>
  ));
};
